import { useQuery } from 'react-query';
import {
	getProductsByAccountBV,
	getProductsWithSizes,
	getProductsWithSizesByClinics,
	getUtilityProducts,
} from '@/services/products';

export const useGetBvProducts = ({
	clinicId,
	clinics,
	userPort,
	enabled = true,
}: {
	clinicId?: string;
	clinics?: string;
	userPort: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['bv-products', clinicId, userPort],
		queryFn: () => getProductsByAccountBV(clinicId || '', userPort, clinics),
		enabled,
		keepPreviousData: false,
	});
};

export const useGetProductsWithSizes = ({
	clinicId,
	userPort,
	enabled = true,
}: {
	clinicId: string;
	userPort: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['products-with-sizes', clinicId, userPort],
		queryFn: () => getProductsWithSizes(clinicId, userPort),
		enabled: enabled && !!clinicId && !!userPort,
		staleTime: 5 * 60 * 1000, // 5 minutes
		// cacheTime: 10 * 60 * 1000, // 10 minutes
		keepPreviousData: true,
	});
};

export const useGetProductsWithSizesByClinics = ({
	clinicIds,
	userPort,
	enabled = true,
}: {
	clinicIds: string[];
	userPort: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['products-with-sizes-by-clinics', clinicIds.join(','), userPort],
		queryFn: () => getProductsWithSizesByClinics(clinicIds, userPort),
		enabled: enabled && clinicIds.length > 0 && !!userPort,
		staleTime: 5 * 60 * 1000,
		keepPreviousData: true,
		select: (data) => data.items, // Return the ClinicProducts map directly
	});
};

export const useGetUtilityProducts = ({
	clinicId,
	userPort,
	enabled = true,
}: {
	clinicId: string;
	userPort: string;
	enabled?: boolean;
}) => {
	return useQuery({
		queryKey: ['products', clinicId, userPort],
		queryFn: () => getUtilityProducts(clinicId, userPort),
		enabled,
		keepPreviousData: false,
	});
};
